import { SyncModelPermissionEntryWithStatus } from "@/domains/sync-scopes/types";
import { filter } from "lodash-es";

export const getGrantedEmailAddressesForPermissions = ({
  permissions,
}: {
  permissions: SyncModelPermissionEntryWithStatus[];
}) => {
  return filter(
    permissions.map(
      permission =>
        permission.role_kind !== "REVOKED" &&
        permission.scope_kind === "EMAIL_SCOPE" &&
        permission.email_address
    )
  ) as string[];
};
